export default function Vehicles() {
  return <div>N/A</div>;
}
